module.exports = new __parcel__URL__("mining_success_label.8242f11b.png").toString();